// Side-effect module, imported FIRST in main.jsx. ES modules evaluate in
// import order, so this runs before analytics-logger initialises Mixpanel
// (and session replay) and before Sentry. On an /invite/ link it takes the
// host's name (and the date and time of their night) off the address bar and
// sends the visitor to the website's invite, query string intact. See
// redirectInviteToWeb in ./invite.js.
import { redirectInviteToWeb } from './invite';

redirectInviteToWeb();
